import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { getSubLotById, getMyOwnDataById, updateSubLotStore, eraseSubLotById, pushNewEmptySubLot } from '../../../../store/actions/RU/creationSubLotActions';
import { addOptionalsBySubLot } from '../../../../store/actions/carOptionals/carOptionalsActions';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import InputLabel from '@material-ui/core/InputLabel';
import SaveIcon from '@material-ui/icons/Save';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CopyIcon from '../../../../Icons/baselineFileCopy.svg';
import DeleteIcon from '@material-ui/icons/Delete';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import RUDiscountTable from '../UsedRentalsDiscounts/RUDiscountTable';
import UsedRentalsSubLotAPI from '../../../../API/UsedRentalsSubLotsAPI';
import RUCQTable from '../UsedRentalsColorQuantity/RUCQTable';
import RUOptionals from './RUOptionals';
import RUManagementOptionals from '../../UsedRentalsManagement/UsedRentalsEditLots/RUManagementOptionals';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { UR_CREATION_GROUP, NEGOTIATION_PHASE } from '../../../../Utils/Constants';


const styles = theme => ({
  epdRoot: {
    flexGrow: 1,
  },
  paperEP: {
    textAlign: 'left',
    color: theme.palette.text.secondary
  },
  headColor: {
    backgroundColor: '#A5A5A5'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  dividerHead: {
    borderBottom: '2px solid #b23c17'
  },
  marginHead: {
    marginTop: '24px'
  },
  padTopSelect: {
    paddingTop: '8px'
  },
  textWhite: {
    color: '#ffffff'
  },
  dividerMargin: {
    padding: '12px 24px 0px 24px'
  },
  dividerMarginFP: {
    paddingTop: '12px'
  },
  dividerHeadFP: {
    borderBottom: '2px solid #007b7a'
  },
  epPadding: {
    padding: '0px 32px 12px'
  },
  rappelAlign: {
    marginTop: '5px'
  }
});

function InputCurrency(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        if (values.value.length <= 8) {
          onChange({ target: { value: values.value } });
        }
      }}
      decimalScale={2}
      thousandSeparator={'.'}
      decimalSeparator={','}
      allowNegative={true}
      suffix={'€'}
      isNumericString={true}
      allowEmptyFormatting={false}
      maxLength={12}
    />
  );
}
InputCurrency.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

function InputPercentage(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: { value: values.value }
        });
      }}
      isAllowed={(values) => {
        const { formattedValue, floatValue } = values;
        return formattedValue === '' || floatValue <= 100;
      }}
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      suffix='%'
      maxLength={7}
    />
  );
}
InputPercentage.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={10}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

function InputYear(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={4}
    />
  );
}
InputYear.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const DateMask = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={' '}
    />
  );
}
DateMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('dd/mm/yyyy', { maxYear: new Date().getFullYear() });

class RUSubLotExpansionPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openOptionals: false,
      openDialog: false,
      loading: false,
      success: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      openError: false,
      alertMessage: '',
      createdOptionalsData: []
    };
    this.updateOptionalsDisplayList.bind(this);
  }

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      loading: false,
      success: false
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  updateOptionalsDisplayList(oNewOptional) {
    let aCreatedOptionals = Object.assign(this.state.createdOptionalsData);
    aCreatedOptionals.push(oNewOptional);
    this.setState({ createdOptionalsData: aCreatedOptionals });
  }

  updateScheduleNumRef = () => {
    const uUsedRentalsSubLotAPI = new UsedRentalsSubLotAPI();
    let dto = {
      Id: this.props.subLotId,
      NumClientRefSchedule: this.props.mySubLotData.NumClientRefSchedule,
      NumClientRefScheduleDate: this.props.mySubLotData.NumClientRefScheduleDate
    };

    this.setState({ loading: true });
    uUsedRentalsSubLotAPI.updateAgendamentoNumRefL2(dto).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      this.props.undetectChange();
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  }

  handleChange = propName => event => {
    this.props.updateSubLotStore(propName, handleSpecialCharacters(event.target.value), this.props.subLotId);
    this.props.detectChange();
  };

  handleClickDelete = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ELIMINAR o Sublote?',
      confirmationMessage: 'A informação contida neste sublote será eliminada e não poderá ser recuperada.',
      confirmationFunction: this.handleSubmitDelete,
      cancelFunction: this.handleCloseDialog
    });
  };

  handleClickDuplicateSub = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende DUPLICAR o Sublote?',
      confirmationMessage: 'A informação referente a este sublote será replicada e será criado um novo sublote com a mesma.',
      confirmationFunction: this.handleSubmitDuplicateSubLot,
      cancelFunction: this.handleCloseDialog
    });
  };

  storeHasOneSubLot = () => {
    var length = 0;
    for (var key in this.props.usedRentalsSubLots) {
      if (this.props.usedRentalsSubLots.hasOwnProperty(key)) {
        ++length;
      }
    }
    return length === 1;
  }

  handleSubmitDelete = () => {
    const negotiationSubLotAPI = new UsedRentalsSubLotAPI();
    this.setState({ loading: true });
    if (!this.props.mySubLotData.Id) {
      if (this.storeHasOneSubLot()) {
        this.props.pushNewEmptySubLot();
        this.props.eraseSubLotById(this.props.subLotId);
      } else {
        this.props.eraseSubLotById(this.props.subLotId);
      }
      this.handleCloseDialog();
    }
    else {
      negotiationSubLotAPI.deleteSubLot(this.props.subLotId).then(() => {
        this.props.reloadTable();
        if (this.storeHasOneSubLot()) {
          this.props.pushNewEmptySubLot();
          this.props.eraseSubLotById(this.props.subLotId);
        } else {
          this.props.eraseSubLotById(this.props.subLotId);
        }
        this.setState({
          loading: false,
          success: true
        });
        this.handleCloseDialog();
      }).catch((error) => {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
        this.handleCloseDialog();
      });
    }
  };

  handleSubmitDuplicateSubLot = () => {
    const usedRentalsSubLotAPI = new UsedRentalsSubLotAPI();
    this.setState({ loading: true });
    usedRentalsSubLotAPI.cloneSubLot(this.props.subLotId).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.handleCloseDialog()
        this.handleClose()
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog()
    });
  };

  expandPanel(evt, isOpening) {
    if (!isOpening)
      return;
    if (!this.props.mySubLotData.Id) {
      if (!this.props.subLotCarOptionals[this.props.subLotId]) {
        this.props.addOptionalsBySubLot(this.props.subLotId, []);
        return;
      }
      return;
    }
    if (!this.props.mySubLotData.ShouldPersist)
      this.props.getSubLotById(this.props.mySubLotData.Id);
  }

  rappelTypeList() {
    return this.props.rappelData ?
      this.props.rappelData.map(n => {
        return (
          <MenuItem key={n.value} value={n.value}>{n.label !== null && n.label !== undefined ? n.label : ''}</MenuItem>
        );
      })
      : '';
  }

  subLotOptionalsGrid() {
    const { classes } = this.props;
    if (this.props.subLotCarOptionals[this.props.subLotId]) {
      return this.props.subLotCarOptionals[this.props.subLotId].map((nOptionalID) => {

        let oOptional = this.props.optionalsData.filter((oItem) => {
          // eslint-disable-next-line
          return oItem.value == nOptionalID;
        }, nOptionalID);

        if (!oOptional.length) {
          oOptional = this.state.createdOptionalsData.filter((oItem) => {
            // eslint-disable-next-line
            return oItem.value == nOptionalID;
          }, nOptionalID);
        }

        const sOptionalDescription = (oOptional[0]) ? oOptional[0].label : '';

        return (
          <Grid item xs={12} sm={2} key={nOptionalID}>
            <Typography variant='body1' className={classes.textWhite}>
              {sOptionalDescription}
            </Typography>
          </Grid>
        );
      }, this);
    }
  }


  render() {
    const { classes } = this.props;
    const shouldDisableActions = (this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0 || !this.props.mySubLotData.Id);

    return (
      <div id={'subLot' + this.props.subLotId} >
        {this.props.lotPhase === 'creationUsedRentals' ?
          <Grid item xs={12} sm={12} className={classNames(classes.dividerMargin, classes.dividerHead)}>
            <Typography variant='headline'>OPCIONAIS NEGOCIADOS L2</Typography>
          </Grid>
          :
          this.props.lotPhase === 'usedRentals' ?
            <Grid item xs={12} sm={12} className={classNames(classes.dividerMarginFP, classes.dividerHeadFP)}>
              <Grid container alignItems='center'>
                <Grid item xs={12} sm={6}>
                  <Typography variant='headline'>OPCIONAIS NEGOCIADOS L2</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container justify='flex-end' alignItems='center'>
                    <RUManagementOptionals subLotId={this.props.subLotId} estadoId={this.props.estadoId} optionalsData={this.props.optionalsData} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            :
            <Grid item xs={12} sm={12} className={classNames(classes.dividerMarginFP, classes.dividerHeadFP)}>
              <Typography variant='headline'>OPCIONAIS NEGOCIADOS L2</Typography>
            </Grid>
        }

        <ExpansionPanel className={classes.headColor} onChange={this.expandPanel.bind(this)}>

          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Grid container spacing={8} justify='flex-start' alignItems='center'>
              {this.subLotOptionalsGrid()}
            </Grid>
          </ExpansionPanelSummary>

          <Paper className={classes.paperEP}>
            <ExpansionPanelDetails className={classes.epPadding}>
              <div className={classes.epdRoot}>

                <Grid container spacing={8}>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='QUANTIDADE'
                      margin='dense'
                      fullWidth
                      value={(this.props.mySubLotData.Quantity !== null && this.props.mySubLotData.Quantity !== undefined) ? this.props.mySubLotData.Quantity.toString() : ''}
                      onChange={this.handleChange('Quantity')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputNumber }}
                    />
                  </Grid>

                  {this.props.estadoId === NEGOTIATION_PHASE && this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) > -1 ?
                    <Grid item xs={12} sm={6}>
                      <Grid container justify='flex-end' alignItems='center'>
                        <Tooltip title='Duplicar Sublote' placement='bottom' >
                          <Button variant='fab' disabled={shouldDisableActions} color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickDuplicateSub}>
                            <img src={CopyIcon} alt='Copiar' />
                          </Button>
                        </Tooltip>
                        <RUOptionals subLotId={this.props.subLotId} updateOptionalsDisplayList={(oNewOptional) => { this.updateOptionalsDisplayList(oNewOptional) }} optionalsData={this.props.optionalsData} estadoId={this.props.estadoId} detectChange={this.props.detectChange.bind()} />
                        <Tooltip title='Eliminar Sublote' placement='bottom' >
                          <Button variant='fab' color='primary' disabled={this.props.estadoId !== NEGOTIATION_PHASE} className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickDelete.bind(this.props.subLotId)}>
                            <DeleteIcon />
                          </Button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                    :
                    <Grid item xs={12} sm={6}>
                      <Grid container justify='flex-end' alignItems='center'>
                        <Tooltip title='Guardar Alterações' placement='bottom' >
                          <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.updateScheduleNumRef}>
                            <SaveIcon />
                          </Button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  }

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Nº PROPOSTA AQUISIÇÃO A1'
                      margin='dense'
                      fullWidth
                      value={(this.props.mySubLotData.NumA1 !== null && this.props.mySubLotData.NumA1 !== undefined) ? this.props.mySubLotData.NumA1.toString() : ''}
                      onChange={this.handleChange('NumA1')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputNumber }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Nº PROPOSTA DE REF. CLIENTES'
                      margin='dense'
                      fullWidth
                      value={this.props.mySubLotData.NumClientReferenceProposal !== null && this.props.mySubLotData.NumClientReferenceProposal !== undefined ? this.props.mySubLotData.NumClientReferenceProposal.toString() : ''}
                      onChange={this.handleChange('NumClientReferenceProposal')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputNumber }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Nº PROPOSTA DE REF. CLIENTES (Agendamento)'
                      margin='dense'
                      fullWidth
                      value={this.props.mySubLotData.NumClientRefSchedule}
                      onChange={this.handleChange('NumClientRefSchedule')}
                      InputProps={{
                        inputComponent: InputNumber
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='Nº PROPOSTA DE REF. CLIENTES (Data Agendamento) (dd/mm/aaaa)'
                      margin='dense'
                      fullWidth
                      value={this.props.mySubLotData.NumClientRefScheduleDate}
                      onChange={this.handleChange('NumClientRefScheduleDate')}
                      InputProps={{
                        inputComponent: DateMask,
                        pipe: autoCorrectedDatePipe,
                        placeholder: '',
                        guide: false
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='ANO MATRÍCULA'
                      margin='dense'
                      fullWidth
                      value={(this.props.mySubLotData.LicensePlateRegistrationYear !== null && this.props.mySubLotData.LicensePlateRegistrationYear !== undefined) ? this.props.mySubLotData.LicensePlateRegistrationYear.toString() : ''}
                      onChange={this.handleChange('LicensePlateRegistrationYear')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputYear }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='KMS MÉDIOS'
                      margin='dense'
                      fullWidth
                      value={(this.props.mySubLotData.AverageKm !== null && this.props.mySubLotData.AverageKm !== undefined) ? this.props.mySubLotData.AverageKm.toString() : ''}
                      onChange={this.handleChange('AverageKm')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputNumber }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='RENDA REFERÊNCIA (€)'
                      margin='dense'
                      fullWidth
                      value={(this.props.mySubLotData.ReferenceRentalPrice !== null && this.props.mySubLotData.ReferenceRentalPrice !== undefined) ? this.props.mySubLotData.ReferenceRentalPrice.toString() : ''}
                      onChange={this.handleChange('ReferenceRentalPrice')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputCurrency }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    {/* Empty Grid Element */}
                  </Grid>

                  <Grid container spacing={8}>

                    <Grid item xs={12} sm={12}>
                      <Typography variant='headline' className={classNames(classes.marginHead, this.props.lotPhase === 'creationUsedRentals' ? classes.dividerHead : classes.dividerHeadFP)}>
                        DESCONTOS NEGOCIADOS
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      {this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0 ?
                        <TextField
                          label='RAPPEL'
                          margin='dense'
                          fullWidth
                          InputProps={{ readOnly: true }}
                          value={this.props.mySubLotData.RappellDescription !== null && this.props.mySubLotData.RappellDescription !== undefined ? this.props.mySubLotData.RappellDescription.toString() : ''}
                        />
                        :
                        <FormControl required fullWidth className={classes.padTopSelect}>
                          <InputLabel htmlFor='rappel'>RAPPEL</InputLabel>
                          <Select
                            name='rappel'
                            margin='dense'
                            value={this.props.mySubLotData.RappelDiscountId !== null && this.props.mySubLotData.RappelDiscountId !== undefined ? this.props.mySubLotData.RappelDiscountId : ''}
                            onChange={this.handleChange('RappelDiscountId')}
                          >
                            {this.rappelTypeList()}
                          </Select>
                        </FormControl >
                      }
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label='RAPPEL DETALHE'
                        margin='dense'
                        className={classes.rappelAlign}
                        fullWidth
                        multiline
                        rows='1'
                        rowsMax='3'
                        inputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, maxLength: 250 }}
                        value={this.props.mySubLotData.RappelDiscountDetail !== null && this.props.mySubLotData.RappelDiscountDetail !== undefined ? this.props.mySubLotData.RappelDiscountDetail : ''}
                        onChange={this.handleChange('RappelDiscountDetail')}
                      />
                    </Grid>

                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Typography variant='headline' className={classNames(classes.marginHead, this.props.lotPhase === 'creationUsedRentals' ? classes.dividerHead : classes.dividerHeadFP)}>
                      VALOR AQUISIÇÃO
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label='VALOR INVESTIMENTO SEM IVA (€)'
                      margin='dense'
                      fullWidth
                      value={this.props.mySubLotData.NoVATInvoiceValueString + ''}
                      onChange={this.handleChange('NoVATInvoiceValueString')}
                      InputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, inputComponent: InputCurrency }}
                    />
                  </Grid>

                  <Grid container spacing={8}>

                    <Grid item xs={12} sm={12}>
                      <Typography variant='headline' className={classNames(classes.marginHead, this.props.lotPhase === 'creationUsedRentals' ? classes.dividerHead : classes.dividerHeadFP)}>
                        GANHOS LP
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <RUDiscountTable lotPhase={this.props.lotPhase} estadoId={this.props.estadoId} L2ID={this.props.mySubLotData.Id} L1ID={this.props.negotiationLot.L1ID} lpGainData={this.props.lpGainData} />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        label='OBSERVAÇÕES GANHOS LP'
                        margin='dense'
                        fullWidth
                        multiline
                        rows='1'
                        rowsMax='3'
                        inputProps={{ readOnly: this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0, maxLength: 1000 }}
                        value={this.props.mySubLotData.LPGainsObservations}
                        onChange={this.handleChange('LPGainsObservations')}
                      />
                    </Grid>

                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Typography variant='headline' className={classNames(classes.marginHead, this.props.lotPhase === 'creationUsedRentals' ? classes.dividerHead : classes.dividerHeadFP)}>
                      CORES NEGOCIADAS
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <RUCQTable lotPhase={this.props.lotPhase} estadoId={this.props.estadoId} L2ID={this.props.mySubLotData.Id} L1ID={this.props.negotiationLot.L1ID} colorData={this.props.colorData} />
                  </Grid>

                </Grid>
              </div>
            </ExpansionPanelDetails>
          </Paper>

          <Dialog
            open={this.state.openDialog}
            onClose={this.handleCloseDialog}
          >
            <ConfirmationDialog
              openConfirmationDialog={this.state.openDialog}
              handleClose={this.handleCloseDialog.bind(this)}
              confirmationQuestion={this.state.confirmationQuestion}
              confirmationMessage={this.state.confirmationMessage}
              confirmationFunction={this.state.confirmationFunction.bind(this)}
              cancelFunction={this.state.cancelFunction.bind(this)}
              loading={this.state.loading}
              success={this.state.success}
            />
          </Dialog>

          <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

        </ExpansionPanel>
      </div >
    )
  }
}

RUSubLotExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  optionalsData: PropTypes.array.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    mySubLotData: getMyOwnDataById(state, ownProps.subLotId),
    ...state
  }
};

const mapDispatchToProps = dispatch => ({
  getSubLotById: (nSubLotId) => dispatch(getSubLotById(nSubLotId)),
  eraseSubLotById: (nSubLotId) => dispatch(eraseSubLotById(nSubLotId)),
  updateSubLotStore: (propName, propValue, nSubLotId) => dispatch(updateSubLotStore(propName, propValue, nSubLotId)),
  addOptionalsBySubLot: (nSubLotId, aSubLotOptionalIds) => dispatch(addOptionalsBySubLot(nSubLotId, aSubLotOptionalIds)),
  pushNewEmptySubLot: () => dispatch(pushNewEmptySubLot())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RUSubLotExpansionPanel));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsEditLots/RUSubLotExpansionPanel.js